<ion-content class="app" slot="fixed">
  <div class="app__content onboarding">
    <div class="onboarding__content">
      <img
        alt="{{ 'Logo ' + appName }}"
        class="logo"
        *ngIf="appIcon"
        [src]="appIcon"
      />
      <h1>{{ 'onboarding.welcome.title' | translate:{appName: appName} }}</h1>
      <p>{{ 'onboarding.welcome.desc' | translate:{appName: appName} }}</p>
      <button role="link" class="onboarding__content__button" (click)="start()">
        <span
          >{{ 'onboarding.welcome.start' | translate:{appName: appName} }}</span
        >
        <span
          class="icon"
          [inlineSVG]="'/assets/icons/card/arrow-right.svg'"
        ></span>
      </button>
    </div>
    <div
      tabindex="0"
      role="link"
      class="onboarding__terms"
      (click)="openPrivacyStatement()"
    >
      {{ "page.settings.privacy.desc" | translate }}
    </div>
  </div>
</ion-content>
